// ConfirmResetPopup.js
import styled from 'styled-components';
import { useState } from 'react';

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
`;

const PopupBox = styled.div`
  position: fixed;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 32px 32px 48px;
  border-radius: 12px;
  text-align: center;
  width: 380px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
`;

const Message = styled.p`
  font-size: 16px;
  color: #333;
  margin-bottom: 24px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
`;

const Button = styled.button`
  padding: 10px 24px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  min-width: 100px;
  transition: background-color 0.3s;

  ${({ confirm }) =>
    confirm
      ? `
    background-color: #61cbc9;
    color: white;

    &:hover {
      background-color: #4fb2b1;
    }
  `
      : `
    background-color: #f0f0f0;
    color: #333;

    &:hover {
      background-color: #e0e0e0;
    }
  `}
`;

const ResultMessage = styled.div`
  margin-top: 20px;
  padding: 10px 16px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 6px;
  background-color: ${({ isError }) => (isError ? '#ffe5e5' : '#e5f8f6')};
  color: ${({ isError }) => (isError ? '#d9534f' : '#2c7873')};
  border: 1px solid ${({ isError }) => (isError ? '#d9534f' : '#2c7873')};
  transition: opacity 0.3s ease;
`;

const ConfirmResetPopup = ({ onConfirm, onCancel }) => {
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleConfirm = async () => {
    console.log("📨 點擊 Yes，準備呼叫 onConfirm()");
    try {
      const result = await onConfirm();
      console.log("✅ onConfirm() 成功，回傳：", result);
      const successMessage = result?.message || "Password has been reset to the default successfully.";
      setIsError(false);
      setMessage(successMessage);
      setTimeout(() => {
        onCancel();
      }, 1800);
    } catch (err) {
      console.error("❌ onConfirm() 發生錯誤：", err);
      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to reset password. Please try again.";
      setIsError(true);
      setMessage(errorMessage);
    }
  };


  return (
    <Overlay>
      <PopupBox>
        <Message>Are you sure you want to reset this user's password to the default?</Message>
        <ButtonGroup>
          <Button type="button" confirm onClick={handleConfirm}>Yes</Button>
          <Button onClick={onCancel}>No</Button>
        </ButtonGroup>
        {message && <ResultMessage isError={isError}>{message}</ResultMessage>}
      </PopupBox>
    </Overlay>
  );
};

export default ConfirmResetPopup;
